export const DB_NAME = "MarriageBiodataMaker";
export const PROFILE_PICTURES_STORE = "profilePictures";
export const CUSTOM_ICONS_STORE_NAME = "customHeaderIcons";
export const DB_VERSION = 2;

export class StorageUnavailableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "StorageUnavailableError";
  }
}

export const initDB = async (): Promise<IDBDatabase> => {
  if (typeof indexedDB === 'undefined') {
     throw new StorageUnavailableError("IndexedDB is not supported in this environment");
  }

  return new Promise<IDBDatabase>((resolve, reject) => {
    const attemptOpen = (version: number) => {
      const request = indexedDB.open(DB_NAME, version);

      request.onerror = () => {
        const error = request.error;
        console.error("IndexedDB open error:", error);
        
        // Handle InvalidStateError (often due to private browsing or restricted storage)
        if (error && (error.name === "InvalidStateError" || error.name === "SecurityError")) {
             reject(new StorageUnavailableError("Storage is not available. Please check your browser settings or disable private browsing."));
             return;
        }

        // Handle version error - try with higher version if database exists with higher version
        if (error && error.name === "VersionError") {
          console.warn(`Version mismatch, attempting with version ${version + 1}`);
          attemptOpen(version + 1);
        } else {
          reject(error);
        }
      };

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        
        // Create profilePictures store if it doesn't exist
        if (!db.objectStoreNames.contains(PROFILE_PICTURES_STORE)) {
          db.createObjectStore(PROFILE_PICTURES_STORE);
        }
        
        // Create customHeaderIcons store if it doesn't exist
        if (!db.objectStoreNames.contains(CUSTOM_ICONS_STORE_NAME)) {
          db.createObjectStore(CUSTOM_ICONS_STORE_NAME);
        }
      };

      request.onsuccess = () => {
        const db = request.result;
        
        // Generic error handler for the database connection
        db.onerror = (event: any) => {
            console.error("Database error:", event.target.error);
        };
        
        resolve(db);
      };
      
      request.onblocked = () => {
          console.warn("IndexedDB blocked: another connection is open.");
      };
    };

    // Start with the defined const version
    attemptOpen(DB_VERSION);
  });
};
